// extracted by mini-css-extract-plugin
module.exports = {"whyContainer":"WhyFinancing-module__whyContainer","title":"WhyFinancing-module__title","points":"WhyFinancing-module__points","point":"WhyFinancing-module__point"};